import { SimulationCaseList_simulationCaseList } from "__generated__/types";
import { Button } from "common/buttons";
import { urls } from "common/urls";
import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Simulation.module.css";

type CaseProps = {
  data: SimulationCaseList_simulationCaseList[] | null;
};

function getRandomCases(
  cases: SimulationCaseList_simulationCaseList[],
  maxCases: number,
): SimulationCaseList_simulationCaseList[] {
  if (cases.length <= maxCases) return cases;
  const randomCases: SimulationCaseList_simulationCaseList[] = [];
  const casesCopy = [...cases];

  while (casesCopy.length > 0 && randomCases.length < maxCases) {
    const randomIndex = Math.floor(Math.random() * casesCopy.length);
    const selectedCase = casesCopy[randomIndex];

    if (!randomCases.includes(selectedCase)) {
      randomCases.push(selectedCase);
    }
  }

  return randomCases;
}

export const Schedule: React.FC<CaseProps> = ({ data }) => {
  const navigate = useNavigate();
  const cases = getRandomCases(data || [], 5);

  return (
    <>
      <ul className={styles.weekdays}>
        <li>Man</li>
        <li>Tir</li>
        <li>Ons</li>
        <li>Tor</li>
        <li>Fre</li>
      </ul>
      <ul className={styles.days}>
        <div className={styles.calendarContainer}>
          {cases.map((caseItem) => (
            <>
              <li key={caseItem.id}>{caseItem.title}</li>
              <hr className={styles.separator} />
            </>
          ))}
        </div>
      </ul>
      <Button
        onClick={() => {
          navigate(urls.simulationCase(cases.shift()?.id ?? ""), {
            state: { cases },
          });
        }}
      >
        Start timebok
      </Button>
    </>
  );
};
